import { Upload } from "antd";
import classNames from "classnames";
import { useCallback, useMemo, useState } from "react";
import Image from "../Image";
import styles from "./index.module.less";

const { Dragger } = Upload;

const normalIcon =
  "https://cdn.dancf.com/fe-assets/img/2094f58d51cf8eeb50c7bcc1bf57194e.png";
const hoverIcon =
  "https://cdn.dancf.com/fe-assets/img/19d454a98770d52ca7c58169ec018a22.png";

/**
 * antd Upload.Dragger 的封装，支持Dragger的部分参数
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export default function FilePicker(props) {
  const {
    children,
    onPick, // 文件选择回调 (file, fileList) => void
    ChildrenWrapper, // 内容wrapper， (isDragging) => ReactDOM
    maxAmount, // 最大上传文件数，仅渲染
    tip,
    // 支持的Dragged组件参数
    className,
    disabled,
    multiple,
    accept,
    openFileDialogOnClick,
    trackData,
  } = props;

  const [isDragging, setDragging] = useState(false);
  const icon = useMemo(
    () => (isDragging ? hoverIcon : normalIcon),
    [isDragging]
  );

  const onDragging = useCallback(() => setDragging(true), []);
  const onDragEnd = useCallback(() => setDragging(false), []);

  const beforeUpload = useCallback(
    (file, fileList) => {
      setTimeout(() => {
        onPick && onPick(file, fileList);
      }, 100);
      return Promise.reject();
    },
    [onPick]
  );

  return (
    <div
      className={classNames(styles.filePicker, className, { isDragging })}
      onDragOver={onDragging}
      onDragEnd={onDragEnd}
      onDragLeave={onDragEnd}
      onDrop={onDragEnd}
      {...trackData}
    >
      <Dragger
        className={styles.filePicker}
        beforeUpload={beforeUpload}
        disabled={disabled}
        multiple={multiple}
        accept={accept}
        openFileDialogOnClick={openFileDialogOnClick}
        fileList={null}
      >
        {ChildrenWrapper ? (
          <ChildrenWrapper isDragging={isDragging} />
        ) : (
          children || (
            <div
              className={classNames(styles.defaultChildren, {
                [styles.isDragging]: isDragging,
              })}
            >
              <Image width={88} height={88} src={icon} alt={"拖到这里"} />
              {isDragging ? (
                <div className={styles.fuText3}>松开上传</div>
              ) : (
                <>
                  <div className={styles.fuText1}>
                    拖拽图片到这里，或<span>点此添加</span>
                  </div>
                  <div className={styles.fuText2}>
                    {tip ||
                      `每次最多上传${
                        maxAmount ?? 20
                      }张，单张图片体积不超过 20 MB`}
                  </div>
                </>
              )}
            </div>
          )
        )}
      </Dragger>
    </div>
  );
}
